export const navigationHelper = {

    openTab : (path: string | null = null, target = '_blank') : void => {

        if (path)
            window.open(`/${path}`, target);
        else
            window.open(`/`, target);
    },

    to: (path: string | null = null): string => {

        if (path)
            return `/${path}`;

        return `/`;
    },
}